import { TOTAL_SCORE, noResultsText } from 'utils/charts/constants';
import format from 'date-fns/format';
import compareAsc from 'date-fns/compareAsc';
import { generateTrendAnalysisYAxisMin } from 'utils/charts/chart';

export const rmTrendAnalysisChartOptions = (trendData) => {
    const formattedData =
        trendData &&
        trendData
            .filter((item) => typeof item.score === 'number')
            .sort((a, b) =>
                compareAsc(
                    new Date(a.year, a.month - 1),
                    new Date(b.year, b.month - 1)
                )
            )
            .reduce(
                (acc, curr) => [
                    ...acc,
                    [
                        format(new Date(curr.year, curr.month - 1), 'MMM-yy'),
                        curr.score
                    ]
                ],
                []
            );

    const dateList = formattedData && formattedData.map((item) => item[0]);
    const valueList = formattedData && formattedData.map((item) => item[1]);
    return {
        title: {
            left: 'left',
            text: 'Trend Analysis',
            textStyle: {
                color: '#244B60',
                fontSize: '12px'
            }
        },
        xAxis: [
            {
                data: dateList || [],
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                axisLabel: {
                    show: true,
                    padding: [16, 0, 0, 0]
                }
            }
        ],
        yAxis: [
            {
                name: TOTAL_SCORE,
                nameLocation: 'center',
                nameTextStyle: {
                    color: '#7FADBF',
                    fontWeight: 600,
                    fontSize: 12
                },
                nameGap: 60,
                axisLabel: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                min: generateTrendAnalysisYAxisMin(valueList)
            }
        ],
        series: [
            {
                type: 'line',
                symbolSize: [7, 7],
                data: valueList || [],
                lineStyle: {
                    color: '#929292'
                },
                itemStyle: {
                    color: '#929292'
                },
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 10,
                    fontWeight: 700,
                    lineheight: 14,
                    offset: [0, -4],
                    formatter: '{c}'
                },
                cursor: 'default'
            }
        ],
        grid: {
            width: '400px',
            height: '60%',
            top: '20%',
            left: '15%'
        },
        graphic: !dateList || dateList.length === 0 ? [noResultsText] : []
    };
};
